import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import AlertTemplate, { AlertTypes } from '@components/Alert/Alert';
import ArticleTemplate from '@components/Article/Article';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import { publicAssets } from '@utils/url.utils';
import { IS_PROD, ROUTES } from '../../constants';
import { IArticleItem } from '../../interfaces/Article';
import { articleApi } from '../../services/article.service';

interface IArticle {
    status: number;
    article?: IArticleItem;
}

const Article: NextPage<IArticle> = (props) => {
    const { t } = useTranslation();

    if (props?.status && props?.status !== 200) return <AlertTemplate type={AlertTypes.error} />;

    return (
        <>
            <NextSeo
                title={t('seo.page.common')}
                description={props?.article?.annotation}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
                openGraph={{
                    images: [{ url: `https://profivzdelavanie.sk${publicAssets('/og-konferencia.png')}` }],
                }}
            />
            <HeaderTemplate />
            <ContentTemplate withPadding>
                <ArticleTemplate article={props?.article} />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

Article.getInitialProps = async (ctx) => {
    try {
        const { data } = await articleApi.detail(ctx.query.slug as string);

        return {
            status: 200,
            article: data,
        };
    } catch (error) {
        if (error?.response?.status === 404) {
            return ctx.res.writeHead(302, { Location: ROUTES.NOT_FOUND }).end();
        }

        return {
            status: 500,
        };
    }
};

export default Article;
